import React, {Suspense} from 'react';
import {Preloader} from '@ab/components';

const Main = React.lazy(() => import(/* webpackChunkName: "Payments" */ './views/main.c'));

const Payments = props => {
    let {match = {}} = props;

    return (
        <Suspense fallback={<Preloader className="center" />}>
            <Main {...props} action={match.params && match.params.action} />
        </Suspense>
    );
};

export default Payments;
